import React, { useState } from "react";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "../ui/dialog";
import { api, formatApiErrorDetail } from "../../lib/api";

export const DeleteSelectedBookings = ({ ids, rows, onDone }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const paid = rows.filter((r) => ids.has(r.id) && r.state === "paid").length;

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/bookings/delete", { ids: [...ids] });
      toast.success(`Deleted ${data.deleted} booking${data.deleted === 1 ? "" : "s"}.`);
      setOpen(false);
      onDone();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };

  return (
    <>
      <button type="button" disabled={!ids.size} onClick={() => setOpen(true)} data-testid="bookings-delete-selected-btn"
        className="btn-secondary inline-flex items-center gap-1.5 text-red-700 disabled:opacity-40">
        <Trash size={16} /> Remove selected ({ids.size})
      </button>
      <Dialog open={open} onOpenChange={(o) => !busy && setOpen(o)}>
        <DialogContent data-testid="bookings-delete-dialog" className="bg-cream-50">
          <DialogHeader>
            <DialogTitle className="font-serif text-2xl">Delete {ids.size} booking{ids.size === 1 ? "" : "s"}?</DialogTitle>
            <DialogDescription>
              These rows are removed permanently and can&apos;t be restored. No refunds are issued and nothing changes in Stripe.
              {paid > 0 && <span data-testid="bookings-delete-paid-warning" className="block mt-2 text-red-700 font-medium">{paid} of these are active paid bookings - their time slots will become free again.</span>}
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <button type="button" onClick={() => setOpen(false)} disabled={busy} data-testid="bookings-delete-cancel-btn" className="btn-secondary">Keep them</button>
            <button type="button" onClick={run} disabled={busy} data-testid="bookings-delete-confirm-btn" className="btn-primary bg-red-700 hover:bg-red-800 disabled:opacity-50">
              {busy ? "Deleting…" : "Delete permanently"}
            </button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
